import { useQuery } from '@tanstack/react-query';
import { type Format } from '@ugin/shared';

import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';

/**
 * Wiring only: each hook is a query key plus the matching client call. The
 * behaviour lives in the client (tested) and in the widgets (tested through a
 * stubbed fetch, so these run for real there).
 */

export function useMatches(params: { format?: Format; deckId?: string; limit?: number } = {}) {
  return useQuery({
    queryKey: queryKeys.matches.list(params),
    queryFn: () => api.matches.list(params),
  });
}

export function useMatch(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.matches.detail(id ?? 'none'),
    queryFn: () => (id ? api.matches.get(id) : Promise.reject(new Error('No match id'))),
    enabled: !!id,
  });
}

export function useStats(format?: Format) {
  return useQuery({
    queryKey: queryKeys.stats.overview(format),
    queryFn: () => api.stats.overview(format),
  });
}

export function useArchetypes(format: Format) {
  return useQuery({
    queryKey: queryKeys.archetypes.forFormat(format),
    queryFn: () => api.archetypes.forFormat(format),
    staleTime: 5 * 60_000,
  });
}
